module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "icon icon-left pull-left",
    on: {
      "click": _vm.goBack
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("收货地址")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block media-list"
  }, [_c('ul', _vm._l((_vm.addressInfo), function(address, index) {
    return _c('li', {
      attrs: {
        "id": index
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'addressModify',
          query: {
            num: index,
            from: _vm.from
          },
          params: {
            order: _vm.$route.params.order
          }
        }
      }
    }, [_c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(address.consignee))]), _vm._v(" "), (address.isDefault == 1) ? _c('div', {
      staticClass: "item-after"
    }, [_vm._v("默认地址")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-subtitle"
    }, [_vm._v(_vm._s(address.expressMobile))]), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_vm._v(_vm._s(address.expressAddress))])])])], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-100",
    attrs: {
      "id": "button-div"
    }
  }, [_c('router-link', {
    staticClass: "button button-big button-fill",
    class: {
      'disabled': _vm.count > 2
    },
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "to": {
        name: 'addAddress',
        query: {
          from: _vm.from
        },
        params: {
          order: _vm.$route.params.order
        }
      },
      "disabled": _vm.count > 2
    }
  }, [_vm._v("\n            新增收货地址\n          ")])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d0213a40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/MyAddress/Address.vue
// module id = 1726
// module chunks = 8